export const formatToggleValue = (value: number | string | boolean): number => {
  if (value) return 1
  return 2
}
